"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_slider_1 = __importDefault(require("react-slider"));
const StyledSlider = styled_components_1.default(react_slider_1.default) `
  width: 100%;
  height: 4px;
  margin: 20px 0px 20px 8px;
`;
const StyledThumb = styled_components_1.default.div `
  height: 26px;
  width: 26px;
  line-height: 24px;
  text-align: center;
  background-color: #006894;
  border: 2px solid #ffffff;
  color: #006894;
  border-radius: 50%;
  top: -11px;
  cursor: grab;

  @media(min-width: 1024px) {
  height: 26px;
  line-height: 20px;
  width: 26px;
  text-align: center;
  border: 2px solid #006894;
  color: #006894;
  border-radius: 50%; 
  letter-spacing: -1.5px;
  padding-right: 2px;
  background: #fff;
  font-family: Nimbus Sans Bold;
  ::before{ 
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-left: 0;
    border-right: 7px solid #006894;
    content: '';
    position: absolute;
    margin: 5px 0 0 -12px;
  }
  ::after{ 
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-right: 0;
    border-left: 7px solid #006894;
    content: '';
    position: absolute;
    margin: 5px 0 0 9px;
  }
  }
`;
const Thumb = (props, state) => (react_1.default.createElement(StyledThumb, Object.assign({}, props), state.valueNow));
const StyledTrack = styled_components_1.default.div `
  top: 0;
  bottom: 0;
  background: #d7dbde;
  border-radius: 999px;
`;
const Track = (props, state) => (react_1.default.createElement(StyledTrack, Object.assign({}, props, { index: state.index })));
class Slider extends react_1.Component {
    render() {
        const { value, min, max, onChange, ariaLabel } = this.props;
        return (react_1.default.createElement(StyledSlider, { value: value, min: min, max: max, renderTrack: Track, renderThumb: Thumb, onChange: onChange, ariaLabel: ariaLabel ? ariaLabel : 'Slider Controller Element' }));
    }
}
exports.default = Slider;
//# sourceMappingURL=Slider.js.map